/**
 * The old address of a custom MCP server's page; it opens in Apps now
 * (`/$org/apps/custom/$serverId`), so old links keep working.
 *
 * @module routes/$org.compliance.integrations_.custom.$serverId
 */
import { createFileRoute } from "@tanstack/react-router";

import { redirectLegacyIntegrations } from "../components/apps/legacyIntegrationsRoute";

export const Route = createFileRoute("/$org/compliance/integrations_/custom/$serverId")({
  beforeLoad: ({ params, location }) => redirectLegacyIntegrations(location.pathname, params.org),
});
